import React, {useState} from "react";
import {Navigation} from "swiper/modules";
import {Swiper, SwiperSlide} from "swiper/react";
import {Image} from "react-bootstrap";
import {img} from "../../utils/ImageUtil.ts";
import {isNotEmpty} from "../../utils/CommonUtil.ts";

interface GiftCategorySwiperProps{
    categoryList: GiftCategoryDto[];
    appendClass?: string;
    handleSelected?: (dto: GiftCategoryDto) => void;
}

const GiftCategorySwiper:React.FC<GiftCategorySwiperProps> = (
    {
        categoryList = [],
        appendClass = '',
        handleSelected = () => {}
    }
) => {
    const [selectedCode, setSelectedCode] = useState<string>("");
    const onClickCategory = (dto: GiftCategoryDto) => {
        setSelectedCode(dto.code);
        handleSelected(dto);
    }
    if(categoryList && categoryList.length != 0){
        return (
            <Swiper className={appendClass}
                    spaceBetween={0}
                    slidesPerView={4}
                    navigation={{
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }}
                    modules={[Navigation]}
                    breakpoints={{
                        768: {slidesPerView: 5}
                    }}
            >
                {categoryList.length > 1 &&
                    <SwiperSlide className={`${isNotEmpty(selectedCode)? '' : 'selected-slide'}`}>
                        <dl className="gift-category-slide-item"
                            onClick={() => {onClickCategory({code: "", name: "すべて"})}}
                        >
                            <dd>
                                <Image src={img('gift_categories/icons/all.png')}
                                       fluid={true}
                                />
                            </dd>
                            <dt>すべて</dt>
                        </dl>
                    </SwiperSlide>
                }
                {categoryList.map( ((categoryDto, idx) => (
                    <SwiperSlide key={`gift_cat_slide_item_${idx}`}
                                 className={`${categoryDto.code === selectedCode ? 'selected-slide': ''}`}
                    >
                        <dl className="gift-category-slide-item"
                            onClick={() => {onClickCategory(categoryDto)}}
                        >
                            <dd>
                                <Image src={img(categoryDto.icon_path)}
                                       fluid={true}
                                />
                            </dd>
                            <dt>{categoryDto.name}</dt>
                        </dl>
                    </SwiperSlide>
                )))}
                <div className="swiper-button-prev"></div>
                <div className="swiper-button-next"></div>
            </Swiper>
        );
    }else {
        return null;
    }
}
export default GiftCategorySwiper;